var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomwebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 512,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 1707 1707",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_194491216"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_194490568"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m911 1372h-116c-8 0-15-6-16-14l-20-146c-15-7-29-15-42-25l-136 56c-8 4-17 1-21-7l-58-100c-4-7-2-17 4-22l117-90c-1-8-1-16-1-24s0-16 1-24l-117-90c-6-5-8-14-4-22l58-100c4-8 13-11 21-7l136 56c13-10 27-18 42-25l20-146c1-8 8-14 16-14h116c9 0 16 6 17 14l19 146c15 7 29 15 42 25l137-56c7-4 16-1 21 7l58 100c4 8 2 17-5 22l-116 90c0 8 1 16 1 24s-1 16-1 24l116 90c7 5 9 15 5 22l-58 100c-5 8-14 11-21 7l-137-56c-13 10-27 18-42 25l-19 146c-1 8-8 14-17 14zm-101-33h87l19-141c0-6 4-11 10-14 18-7 35-17 51-29 4-4 11-5 16-2l132 54 43-75-112-87c-5-4-8-10-7-16 2-9 2-19 2-29s0-20-2-29c-1-6 2-12 7-16l112-87-43-75-132 54c-5 3-12 2-16-2-16-12-33-22-51-29-6-3-10-8-10-14l-19-141h-87l-19 141c-1 6-5 11-10 14-19 7-36 17-51 29-5 4-11 5-17 2l-131-54-44 75 113 87c5 4 7 10 6 16-1 9-2 19-2 29s1 20 2 29c1 6-1 12-6 16l-113 87 44 75 131-54c6-3 12-2 17 2 15 12 32 22 51 29 5 3 9 8 10 14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_194491624"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m853 1139c-76 0-138-63-138-139s62-139 138-139c77 0 139 63 139 139s-62 139-139 139zm0-244c-58 0-105 47-105 105s47 105 105 105 106-47 106-105-48-105-106-105z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_194491240"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1690 1633h-1673c-9 0-17-7-17-17v-1232c0-10 8-17 17-17h1673c9 0 17 7 17 17v1232c0 10-8 17-17 17zm-1657-33h1640v-1200h-1640z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_194490952"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1690 400h-1673c-9 0-17-7-17-16v-294c0-9 8-16 17-16h1673c9 0 17 7 17 16v294c0 9-8 16-17 16zm-1657-33h1640v-260h-1640z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_194491048"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m191 327c-49 0-90-41-90-90 0-50 41-90 90-90 50 0 90 40 90 90 0 49-40 90-90 90zm0-147c-31 0-56 26-56 57s25 56 56 56 57-25 57-56-26-57-57-57z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_194492248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m398 327c-49 0-90-41-90-90 0-50 41-90 90-90 50 0 90 40 90 90 0 49-40 90-90 90zm0-147c-31 0-56 26-56 57s25 56 56 56 57-25 57-56-26-57-57-57z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_194492296"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m605 327c-49 0-90-41-90-90 0-50 41-90 90-90 50 0 90 40 90 90 0 49-40 90-90 90zm0-147c-31 0-56 26-56 57s25 56 56 56 57-25 57-56-26-57-57-57z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_194492320"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1628 254h-841c-10 0-17-8-17-17s7-17 17-17h841c9 0 17 8 17 17s-8 17-17 17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_194491744"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1478 1487h-1249c-9 0-17-7-17-17 0-9 8-16 17-16h1249c9 0 16 7 16 16 0 10-7 17-16 17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_194492344"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1478 546h-1249c-9 0-17-7-17-16 0-10 8-17 17-17h1249c9 0 16 7 16 17 0 9-7 16-16 16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_194492080"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m294 1364c-9 0-16-8-16-17v-694c0-9 7-17 16-17 10 0 17 8 17 17v694c0 9-7 17-17 17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_194492392"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1412 1364c-9 0-16-8-16-17v-694c0-9 7-17 16-17 10 0 17 8 17 17v694c0 9-7 17-17 17z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomwebsite);
export default __webpack_public_path__ + "static/media/customwebsite.ebd71802a59d4536734b4cc472ea8ead.svg";
export { ForwardRef as ReactComponent };